/**
 * Single Firebase config — one app, one Firestore (with persistence).
 * Only initializes when required env vars are set; otherwise exports undefined.
 */
import {
  initializeFirestore,
  getFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  memoryLocalCache,
  Firestore,
} from "firebase/firestore";
import { auth, googleProvider, facebookProvider, appleProvider } from "./auth-config";
import app, { hasConfig } from "./app-core";

let db: Firestore | undefined;

function firestoreErrorMessage(error: unknown): string {
  if (error && typeof error === "object" && "message" in error) {
    return String((error as { message?: string }).message);
  }
  return "";
}

if (hasConfig && app) {
  try {
    db = initializeFirestore(app, {
      localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager(),
      }),
    });
  } catch (e: unknown) {
    const msg = firestoreErrorMessage(e);
    if (msg.includes("already been called")) {
      db = getFirestore(app);
    } else {
      // IndexedDB is unavailable (private mode, quota, dropped connection).
      try {
        db = initializeFirestore(app, {
          localCache: memoryLocalCache(),
        });
      } catch {
        db = getFirestore(app);
      }
    }
  }
}

export { auth, googleProvider, facebookProvider, appleProvider, db };
export default app;
